import { makeActionCreator } from '../../config/store/utils'
import { getProviderTradedAmounts } from '../../services/providers'

const COLORS_DICTIONARY = {
  1: 'seance',
  2: 'toryBlue',
  3: 'denim',
  4: 'cinnabar',
  5: 'tangerine',
  6: 'apple',
  7: 'saffron'
}

export const GET_PROVIDER_TRADED_AMOUNTS = 'GET_PROVIDER_TRADED_AMOUNTS'
export const GET_PROVIDER_TRADED_AMOUNTS_ERROR = 'GET_PROVIDER_TRADED_AMOUNTS_ERROR'
export const GET_PROVIDER_TRADED_AMOUNTS_SUCCESS = 'GET_PROVIDER_TRADED_AMOUNTS_SUCCESS'
export const onGetProviderTradedAmounts = makeActionCreator(GET_PROVIDER_TRADED_AMOUNTS)
export const onGetProviderTradedAmountsError = makeActionCreator(GET_PROVIDER_TRADED_AMOUNTS_ERROR, 'payload')
export const onGetProviderTradedAmountsSuccess = makeActionCreator(GET_PROVIDER_TRADED_AMOUNTS_SUCCESS, 'payload')
export const onGetProviderTradedAmountsThunk = payload => async dispatch => {
  dispatch(onGetProviderTradedAmounts())

  try {
    const { data } = await getProviderTradedAmounts({
      dni: payload.dni,
      mechanismId: payload.mechanismId,
      year: payload.year
    })
    const enhancedData =
      data.payload.map(item => ({
        amount: item.amountCLPSectorAnnual,
        amountUSD: item.amountUSDSectorAnnual,
        colorName: COLORS_DICTIONARY[payload.sectorId],
        id: item.idSector,
        name: item.sector,
        orders: item.numberOCSectorAnnual,
        percentage: item.percentageSectorAnnual,
        y: item.amountCLPSectorAnnual,
        year: payload.year,
        z: item.idSector === payload.sectorId ? 100 : 70
      })) || []
    const csv = [
      ['Año', 'Sector', 'Monto transado', 'Monto transado (USD)', 'Nº de órdenes de compra'],
      ...enhancedData.map(item => [item.year, item.name, item.amount, item.amountUSD, item.orders])
    ]
    const [item] = data.payload || []

    return dispatch(
      onGetProviderTradedAmountsSuccess({
        csv,
        data: enhancedData,
        totalAmount: item?.amountCLPNationalAnnual || 0,
        totalAmountUSD: item?.amountUSDNationalAnnual || 0,
        totalOrders: item?.numberOCNationalAnnual || 0
      })
    )
  } catch (error) {
    return dispatch(onGetProviderTradedAmountsError({ error }))
  }
}
